import {
  InstagramOutlined, FacebookOutlined, YoutubeOutlined, LinkedinOutlined, GlobalOutlined,
} from '@ant-design/icons';
import { urlDeRed } from './urlSegura';

/**
 * Las CINCO redes sociales que el productor puede cargar, compartidas por DOS
 * dominios: la página de contacto del remate (`ContactoPage.jsx`) y la barra
 * de bienvenida del catálogo de genética (`BarraBienvenida.jsx`). Nació
 * adentro de `ContactoPage` como la única lista; cuando la barra empezó a
 * necesitar los mismos íconos, colores y armado de `href`, copiarla habría
 * dejado dos listas que divergen la primera vez que alguien agregue una red
 * nueva en una y se olvide de la otra. Mismo criterio que fija `AGENTS.md`
 * para los hooks: "si algo se usa desde otro dominio, se muda, no se copia".
 *
 * El armado de cada `href` vive en `urlDeRed` (`utils/urlSegura.js`): el
 * productor pega indistintamente el usuario (`cabana.pilaga`) o la URL
 * completa copiada del navegador, y sin distinguir los dos casos salía
 * https://instagram.com/https://instagram.com/cabana.
 *
 * NO incluye WhatsApp: `ContactoPage` arma ese `href` distinto —limpia el
 * teléfono a dígitos, no pasa por `urlDeRed`— y por ahora sólo lo usa ahí.
 */
export const REDES = [
  { key: 'instagram', icon: <InstagramOutlined />, color: '#e1306c', label: 'Instagram', href: (v) => urlDeRed(v, 'https://instagram.com/') },
  { key: 'facebook', icon: <FacebookOutlined />, color: '#1877f2', label: 'Facebook', href: (v) => urlDeRed(v, 'https://facebook.com/') },
  { key: 'youtube', icon: <YoutubeOutlined />, color: '#ff0000', label: 'YouTube', href: (v) => urlDeRed(v, 'https://youtube.com/@') },
  { key: 'linkedin', icon: <LinkedinOutlined />, color: '#0a66c2', label: 'LinkedIn', href: (v) => urlDeRed(v, 'https://linkedin.com/in/') },
  { key: 'twitter', icon: <GlobalOutlined />, color: '#000', label: 'X', href: (v) => urlDeRed(v, 'https://x.com/') },
];
